// pp-liga-cotizador.js — el GEMELO en JS de snippets/pp-liga-cotizador.liquid.
//
// La liga al cotizador de cajas a la medida (cotizador.parapaquetes.com/cajas; antes cajas.parapaquetes.com, que redirige con 301) tiene UN
// dueño por lenguaje: en Liquid el snippet, en el navegador este archivo. La
// base y los nombres de parámetro son los mismos en los dos y
// tests/cotizador-entradas.test.mjs los carea — si uno cambia sin el otro,
// truena el CI, no la venta.
//
// Contrato con apps/cajas (monorepo): largo/ancho/alto en cm (las TRES o
// ninguna), estilo (código de cajas.box_styles), cantidad, y utm_source /
// utm_medium / utm_campaign para saber de dónde llegó cada cotización.
//
// Además cablea UN caso que Liquid no puede resolver: la colección de cajas
// que se quedó en CERO con filtros. Shopify deja de reportar los filtros
// activos cuando el resultado es vacío (medido el 24-sep-2026, ver
// sections/pp-collection-detailed.liquid), así que las medidas filtradas sólo
// se pueden leer de location.search. Un ancla con
// `data-pp-liga-cotizador-filtros` se reescribe aquí con esas medidas.
(function (root) {
  'use strict';

  var BASE = 'https://cotizador.parapaquetes.com/cajas/';
  var FILTROS_MEDIDA = {
    largo: 'filter.p.m.custom.largo',
    ancho: 'filter.p.m.custom.ancho',
    alto: 'filter.p.m.custom.alto'
  };

  // Un cm limpio > 0 a 1 decimal, o null. Acepta "20", "20.5", "20 cm", 20.
  function cmLimpio(x) {
    if (x === null || x === undefined) return null;
    var s = String(x).toLowerCase().replace('cm', '').replace(',', '.').trim();
    if (!/^\d{1,6}(?:\.\d+)?$/.test(s)) return null;
    var v = Number(s);
    if (!(v > 0)) return null;
    return String(Math.round(v * 10) / 10);
  }

  // Un valor de utm limpio (texto corto, sin control ni <>), o null.
  function utmLimpio(x) {
    if (typeof x !== 'string') return null;
    var s = x.trim().slice(0, 100);
    if (s === '' || /[\u0000-\u001f\u007f<>]/.test(s)) return null;
    return s;
  }

  // { largo, ancho, alto, estilo, cantidad, flauta, acabado, medio, campana,
  //   fuente, termino, contenido } ⇒ URL completa. `fuente` (utm_source) es
  // `tienda` salvo que alguien más (Paco, una campaña) haya mandado la suya a
  // /pages/cotizador-de-cajas: esa página la conserva, no se la apropia.
  // flauta (B|C) y acabado (kraft|blanco) sólo se pasan si son de ese catálogo.
  function armar(o) {
    o = o || {};
    var partes = [];
    var l = cmLimpio(o.largo), a = cmLimpio(o.ancho), h = cmLimpio(o.alto);
    if (l && a && h) partes.push('largo=' + l, 'ancho=' + a, 'alto=' + h);
    if (typeof o.estilo === 'string' && o.estilo.trim() !== '') {
      partes.push('estilo=' + encodeURIComponent(o.estilo.trim()));
    }
    var n = Math.floor(Number(o.cantidad));
    if (n > 0) partes.push('cantidad=' + n);
    var flauta = typeof o.flauta === 'string' ? o.flauta.trim().toUpperCase() : '';
    if (flauta === 'B' || flauta === 'C') partes.push('flauta=' + flauta);
    var acabado = typeof o.acabado === 'string' ? o.acabado.trim().toLowerCase() : '';
    if (acabado === 'kraft' || acabado === 'blanco') partes.push('acabado=' + acabado);
    var medio = typeof o.medio === 'string' && o.medio.trim() !== '' ? o.medio.trim() : 'tienda';
    var fuente = utmLimpio(o.fuente);
    partes.push(fuente ? 'utm_source=' + encodeURIComponent(fuente) : 'utm_source=tienda', 'utm_medium=' + encodeURIComponent(medio));
    if (typeof o.campana === 'string' && o.campana.trim() !== '') {
      partes.push('utm_campaign=' + encodeURIComponent(o.campana.trim()));
    }
    var termino = utmLimpio(o.termino), contenido = utmLimpio(o.contenido);
    if (termino) partes.push('utm_term=' + encodeURIComponent(termino));
    if (contenido) partes.push('utm_content=' + encodeURIComponent(contenido));
    return BASE + '?' + partes.join('&');
  }

  // RAMA DE BOLSA (R-5 «Ver alternativas», 19-oct-2026). El gemelo de la
  // rama `linea: 'bolsa'` del snippet: cotizador.parapaquetes.com/bolsas con
  // ?tipo=<id>&ancho=<cm>&largo=<cm>&utm_source=tienda&utm_medium=<lugar>
  // (contrato de /bolsas, monorepo #9042). Ancho y largo van JUNTOS o
  // ninguno; un tipo fuera del catálogo no viaja.
  var BASE_BOLSAS = 'https://cotizador.parapaquetes.com/bolsas';
  var TIPOS_BOLSA = ['plana', 'fuelle-lateral', 'fuelle-fondo', 'envio', 'camiseta'];

  function armarBolsa(o) {
    o = o || {};
    var partes = [];
    var tipo = typeof o.tipo === 'string' ? o.tipo.trim().toLowerCase() : '';
    if (TIPOS_BOLSA.indexOf(tipo) !== -1) partes.push('tipo=' + tipo);
    var a = cmLimpio(o.ancho), l = cmLimpio(o.largo);
    if (a && l) partes.push('ancho=' + a, 'largo=' + l);
    var producto = typeof o.producto === 'string' ? o.producto.trim().toLowerCase() : '';
    if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(producto) && producto.length <= 40) partes.push('producto=' + producto);
    var medio = typeof o.medio === 'string' && o.medio.trim() !== '' ? o.medio.trim() : 'tienda';
    partes.push('utm_source=tienda', 'utm_medium=' + encodeURIComponent(medio));
    if (typeof o.campana === 'string' && o.campana.trim() !== '') {
      partes.push('utm_campaign=' + encodeURIComponent(o.campana.trim()));
    }
    return BASE_BOLSAS + '?' + partes.join('&');
  }

  // RAMA DE CINTA (landings de personalizados, 3-nov-2026): gemelo de
  // `linea: 'cinta'` del snippet. /cinta redirige al estudio con su query;
  // `cinta` (id de la cinta base) sólo si es entero > 0.
  var BASE_CINTA = 'https://cotizador.parapaquetes.com/cinta';

  function armarCinta(o) {
    o = o || {};
    var partes = [];
    var n = Math.floor(Number(o.cinta));
    if (n > 0) partes.push('cinta=' + n);
    var medio = typeof o.medio === 'string' && o.medio.trim() !== '' ? o.medio.trim() : 'tienda';
    partes.push('utm_source=tienda', 'utm_medium=' + encodeURIComponent(medio));
    if (typeof o.campana === 'string' && o.campana.trim() !== '') {
      partes.push('utm_campaign=' + encodeURIComponent(o.campana.trim()));
    }
    return BASE_CINTA + '?' + partes.join('&');
  }

  // Las medidas de los filtros de colección, o null. Sólo si cada eje trae
  // UN valor: con dos largos marcados no hay «la» medida que pidió.
  function medidasDeFiltros(busqueda) {
    var params;
    try { params = new URLSearchParams(busqueda || ''); } catch (e) { return null; }
    var out = {};
    for (var eje in FILTROS_MEDIDA) {
      var vals = params.getAll(FILTROS_MEDIDA[eje]);
      if (vals.length !== 1) return null;
      var cm = cmLimpio(vals[0]);
      if (!cm) return null;
      out[eje] = cm;
    }
    return out;
  }

  function cablearFiltros(doc, busqueda) {
    if (!doc || !doc.querySelectorAll) return;
    var medidas = medidasDeFiltros(busqueda);
    if (!medidas) return;
    var anclas = doc.querySelectorAll('[data-pp-liga-cotizador-filtros]');
    for (var i = 0; i < anclas.length; i++) {
      var a = anclas[i];
      a.href = armar({
        largo: medidas.largo,
        ancho: medidas.ancho,
        alto: medidas.alto,
        estilo: a.getAttribute('data-estilo') || '',
        medio: a.getAttribute('data-medio') || 'coleccion-vacia'
      });
    }
  }

  root.PPLigaCotizador = {
    BASE: BASE,
    FILTROS_MEDIDA: FILTROS_MEDIDA,
    BASE_BOLSAS: BASE_BOLSAS,
    armar: armar,
    armarBolsa: armarBolsa,
    BASE_CINTA: BASE_CINTA,
    armarCinta: armarCinta,
    medidasDeFiltros: medidasDeFiltros,
    cablearFiltros: cablearFiltros
  };

  if (typeof document !== 'undefined' && typeof location !== 'undefined') {
    var correr = function () { cablearFiltros(document, location.search); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', correr);
    else correr();
  }
})(typeof window !== 'undefined' ? window : globalThis);
